window.addEventListener('DOMContentLoaded', (event) => {
  $('.collection-filtering-section,.collection-grid').wrapAll('<div class="layout-fix-collection"></div>')

  // add best for
  $('small p').each(function () {
    $(this).prepend('<strong>Best For</strong>')
  })
  //   $(document).on('change',function(){
  // setTimeout(() => {
  //   $('small p').each(function () {
  //     $(this).prepend('<strong>Best For</strong>')
  //   })
  // }, 3000);
  //   })
  // best sellers dropown

  // about page tag
  var tag = '<div class="banner-lable-wrapper"><span class="banner-lable">LIFE </span><span class="banner-lable"> UNSTOPPABLE</span></div>'
  $('#shopify-section-template--15650287550670__4dc4e380-cc98-44ea-988d-de83b78f554c .responsive-image-wrapper').append(tag);
  // end

  // // browse by body Parts Tag
 var tag4 = '<div class="browse-banner-lable-wrapper"><div class="inner-relative-layer"><div class="inner-absolute-layer"><span class="banner-lable">Enhanced </span><span class="banner-lable"> Protection</span></div></div></div>'
 if(tag4){
   jQuery('#thermoskin-sport-supports-and-braces .banner-with-icon-set').append(tag4);
 }

  // browse by body Parts Tag
  // var tag2 = '<div class="browse-banner-lable-wrapper"><div class="inner-relative-layer"><div class="inner-absolute-layer"><span class="banner-lable">Enhanced </span><span class="banner-lable"> Recovery</span></div></div></div>'
  // $('#thermoskin-thermal-range-of-supports-amp-braces-heat-therapy .banner-with-icon-set').append(tag2);

  // browse by body Parts Tag
  // var tag3 = '<div class="browse-banner-lable-wrapper"><div class="inner-relative-layer"><div class="inner-absolute-layer"><span class="banner-lable">Reduces </span><span class="banner-lable"> Swelling</span></div></div></div>'
  // $('#thermoskin-compression-range-of-supports-and-braces .banner-with-icon-set').append(tag3);

  // browse by body Parts Tag
  // var tag4 = '<div class="browse-banner-lable-wrapper"><div class="inner-relative-layer"><div class="inner-absolute-layer"><span class="banner-lable">Enhanced </span><span class="banner-lable"> Protection</span></div></div></div>'
  // $('#thermoskin-sport-supports-and-braces .banner-with-icon-set').append(tag4);


  var popup = document.querySelector('.best-sellers-nav');
  var tabs = document.querySelectorAll('.best-sellers-nav .best-sellers-tab');
  var dropdown = document.querySelector('.mobile-dropdown .dropdown_value')

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      var content = tab.textContent;
      dropdown.textContent = content;
      dropdown.classList.remove('dropdown_open')
      popup.classList.remove('pop-in')
    })
  })
  if (dropdown != null) {
    dropdown.addEventListener('click', function () {
      if (popup.classList.contains('pop-in')) {
        popup.classList.remove('pop-in')
        dropdown.classList.remove('dropdown_open')
      } else {
        popup.classList.add('pop-in')
        dropdown.classList.add('dropdown_open')
      }
    })
  }
  // end
});





var cd = document.querySelectorAll('.active-facets');
cd.forEach((cdm) => {
  cdm.childElementCount;
  console.log('count')
  console.log(cdm.childElementCount)
  if (cdm.childElementCount == 1) {
    cdm.style.display = 'none';
  }
})
document.querySelectorAll('.facets__item').forEach(
  function (item) {
    item.addEventListener('click', function () {

      cd.forEach((cdm) => {
        cdm.childElementCount;
        console.log('count')
        console.log(cdm.childElementCount)
        if (cdm.childElementCount == 1) {
          cdm.style.display = 'none';
        } else {
          cdm.style.display = 'flex';
        }

      })
    })
  }
)

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// Tax calculetor for product price

function salePriceWIthGST(gst, Saleprice2) {
  var pr = Saleprice2.split('$')
  //console.log('pr2', pr2);
  var newPrice = parseFloat(pr[1]);
  //console.log('newPrice', newPrice);
  let wIthGST = newPrice * gst / 100;
  let newPriceWithGST = parseFloat(pr[1]) + parseFloat(wIthGST)
  return (`$` + newPriceWithGST.toFixed(2))
}

// price with gst 
function priceWIthGST(gst, price) {
  var pr = price.split('$')
  console.log('pr', pr);
  var newPrice = parseFloat(pr[1]);
  console.log('newPrice', newPrice);
  let wIthGST = newPrice * gst / 100;
  console.log('wIthGST', wIthGST);
  let newPriceWithGST = parseFloat(pr[1]) + parseFloat(wIthGST)
  return (`$` + newPriceWithGST.toFixed(2))
}
// non GST update Text 
function nonGStUpdate(list,resorceType) {
  if(resorceType == 'Collection'){
    return
  }
  var nonGst = document.createElement('span');
  nonGst.textContent = ' GST Free';
  list.forEach((listItem) => {
    var checkNonGst = listItem.querySelector('.non-gst');
    if (checkNonGst == null) {
      console.log(listItem)
      listItem.appendChild(nonGst);
    }
  })
}

// update GST
function updateGSTprice(currentElm, gstprice, closestWrapperSelector, toBeUpdatedSelector,resorceType) {
  let span = document.createElement('span');
  //let span2 = document.createElement('span');
  //console.log('currentElm', currentElm)
  span.textContent = gstprice;
  //span2.textContent = gstprice1;
  if (closestWrapperSelector == null && toBeUpdatedSelector == null) {
    span.setAttribute("class", "d-block withGSTPrice")
    //span2.setAttribute("class", "d-block withGSTSalePrice line--through");
      if(resorceType == 'Collection') {
        span.textContent = gstprice;
        //span2.textContent = gstprice1;
      } else {
        span.textContent = gstprice + ' Inc. GST ';
      }
    if (currentElm.parentElement.querySelector('.withGSTPrice') == null) {
      currentElm.parentElement.appendChild(span);
      currentElm.style.display = 'none';
    }
    // currentElm.parentElement.appendChild(span)
  } else if (closestWrapperSelector == 'undefined' || toBeUpdatedSelector == 'undefined') {
    span.setAttribute("class", "d-block")
    if(resorceType == 'Collection'){
      span.textContent = gstprice
    }else {
      span.textContent = gstprice + ' Inc. GST ';
    }
    
    if (currentElm.parentElement.querySelector('.withGSTPrice') == null) {
      currentElm.parentElement.appendChild(span);
    }
    // currentElm.parentElement.appendChild(span);
    currentElm.style.display = 'none';

    } else {
      currentElm.closest(closestWrapperSelector)?.querySelector(toBeUpdatedSelector).appendChild(span);
      currentElm.style.display = 'none';
    }
    currentElm.parentElement.parentElement.classList.remove('loader')
  }

// end
function updateAjaxCartSubtotalGST() {
  var subtotalselect = document.querySelector('.ajaxcart__subtotal .money');
  var subtotalAjaxCartGst = 0;
  var subtotalArr = [];
  var cartItemsWithTax = document.querySelectorAll('.ajaxcart-item__price');
  // var cartItemsWithoutTax = document.querySelectorAll('.taxable--false .ajaxcart-item__price .money');
  cartItemsWithTax.forEach((item) => {
    if (item.querySelector('.withGSTPrice') != null) {
      item = item.querySelector('.withGSTPrice');
    } else {
      item = item.querySelector('.money');
    }
    var pr = item.textContent.split('$')
    var prNew = parseFloat(pr[1]);
    var qnt = parseFloat(item.closest('.grid__item').querySelector('.ajaxcart__qty-num').value);
    var newPrSub = prNew * qnt;
    subtotalArr.push(newPrSub)
    document.querySelector('.ajaxcart__subtotal').classList.remove('loader');

  })
  subtotalArr.forEach((prItem) => {
    subtotalAjaxCartGst += prItem;
  })
  subtotalselect.textContent = '$' + subtotalAjaxCartGst.toFixed(2);
}

window.addEventListener('DOMContentLoaded', (event) => {
  // GST free Added on collection page
  var searchPageGstFreeItems = document.querySelectorAll('.search-wrapper .taxable--false')
  var gstFreeItems = document.querySelectorAll('.collection-main-body .product-grid--price.taxable--false')
 
  var istaxble = window.istaxble;
  //console.log('istaxble', istaxble);
  if (istaxble == true) {
    var priceArr = document.querySelectorAll('.taxable--true .money');
    //console.log('priceArr', priceArr);
    priceArr.forEach((m) => {
      m.parentElement.parentElement.classList.add('loader');
    })
    var taxableArr = document.querySelectorAll('.taxable--false');
    taxableArr.forEach((m) => {
      m.classList.remove('loader');
    })
    //console.warn('tst', window.taxPercentage)
    var gst = parseInt(window.taxPercentage);
    //console.log('gst', gst);
    var price = document.querySelectorAll('.template-product #ProductPrice .money');
    //console.log('price:', price);
    var salePrice2 = document.querySelectorAll('.template-product #ComparePrice .money');
    // GST price add on document load 
    if (price != null) {
      price.forEach((m) => {
        let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
        //console.log('WIthGSTPriceNew', WIthGSTPriceNew);
        updateGSTprice(m, WIthGSTPriceNew, '.price-with-gst-wrapper:not(.taxable--false)', '.with-gst-price')
      })
    }

    if(salePrice2 != null) {
      salePrice2.forEach((m) => {
        let WIthGSTSalePriceNew = salePriceWIthGST(gst, m.textContent);
        console.log('WIthGSTSalePriceNew', WIthGSTSalePriceNew);

        var pdpSalePricediv = document.querySelector('.compareprice-with-gst-price');
        console.log('pdpSalePricediv', pdpSalePricediv);
        if (pdpSalePricediv) {
            pdpSalePricediv.textContent = WIthGSTSalePriceNew;
        }
        
        updateGSTprice(m, WIthGSTSalePriceNew, '.price-with-gst-wrapper:not(.taxable--false)', '.compareprice-with-gst-price')
      });
    } 

    // GST price add on addto cart and cartToggler click 
    var addtocartBtn = document.querySelector('#AddToCart');
    var cartToggleBtn = document.querySelector('.site-header__cart-toggle');
    console.log(cartToggleBtn);
    var arr = [addtocartBtn, cartToggleBtn];
    arr.forEach((el) => {
      if (el != null) {
        el.addEventListener('click', () => {
          //alert('clicked')
              console.log("test");
          // var cartLoder = document.createElement('div')
          // cartLoder.setAttribute('class','cart-loader')
          // document.querySelector('.right-drawer-vue').classList.add('drawer-loader');
          // document.querySelector('.right-drawer-vue').appendChild(cartLoder)
          setTimeout(() => {
            // priceupdate on line tiems
            var prNodes = document.querySelectorAll('.ajaxcart__product .taxable--true .money');
            prNodes.forEach((m) => {
              let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
              updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection')
            })
            // priceupdate on line tiems end

  
            // price update on subtotal after tax changes
            setTimeout(() => {
              updateAjaxCartSubtotalGST()
            }, 1000);
            // price update on subtotal end

            // price update on removeBTN clilck
            var cartRemoveBtns = document.querySelectorAll('.ajaxcart__qty-remove')
            cartRemoveBtns.forEach((cartRemoveBtn) => {
              cartRemoveBtn.onclick = () => {
                document.querySelector('.ajaxcart__subtotal').classList.add('loader')
                setTimeout(() => {
                  updateAjaxCartSubtotalGST()
                  document.querySelector('.ajaxcart__subtotal').classList.remove('loader')
                }, 2500);
              }
            })

            // price update on ajax qtn Chnage button click
            var QTNbutton = document.querySelectorAll('.ajaxcart__product .ajaxcart__qty-adjust')
            QTNbutton.forEach((QTNBtn) => {

              QTNBtn.onclick = () => {
                document.querySelector('.ajaxcart__subtotal').classList.add('loader');
                setTimeout(() => {
                  updateAjaxCartSubtotalGST()
                }, 2000);
                setTimeout(() => {
                  document.querySelector('.ajaxcart__subtotal').classList.remove('loader');
                }, 2050);
              }

            })
            // price update on ajax qtn Chnage button click

          }, 2000);
        })
      }
    })

    // price update on search button click
    var searchButtons = document.querySelectorAll('.search-button');
    searchButtons.forEach((button) => {
      button.onclick = () => {
        setTimeout(() => {
          var SearchInput = document.querySelector('#SearchContainer #search-input');
          var searchResultPrices = document.querySelectorAll('#search-results .money');
          searchResultPrices.forEach((m) => {
            let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
            updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection')
          })
          SearchInput.onkeyup = () => {
            setTimeout(() => {
              var searchResultPrices = document.querySelectorAll('#search-results .money');
              searchResultPrices.forEach((m) => {
                let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
                updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection')
              })
            }, 1000);
          }
        }, 2000);
      }
    })
    // collection price update

    // price update on collection page 

    setTimeout(() => {
      var collecPrList = document.querySelectorAll('.collection-main-body .taxable--true .money:not(.sale-price)');
      console.log('collecPrList', collecPrList);
      var collecPrList1 = document.querySelectorAll('.collection-main-body .taxable--true .money.sale-price');
      console.log('collecPrList1', collecPrList1);
      //var customhidediv = document.querySelectorAll('span.money.line--through.sale-price');
      collecPrList.forEach((m) => {
        let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
        updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection')
        //collecPrList.style.display = 'none';
      })
      //customhidediv.style.display = 'none';
      collecPrList1.forEach((m) => {
        let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
        updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection')
      })
    }, 3000);

    // on varient change 
    var swatch = document.querySelectorAll('.swatch-element label');
    swatch.forEach((s) => {
      s.addEventListener('click', (e) => {
        setTimeout(() => {
          var m = e.target.closest('.form-vertical').querySelector('.money');
          var n = e.target.closest('.form-vertical').querySelector('.with-gst-price span');
          let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
          n.textContent = WIthGSTPriceNew;
          m.style.display = 'none'
          console.log('new GST variable price updated');
        }, 500);

      })
    })
    // on collection page filter click  
    var filter = document.querySelector('.collection-filtering-section')

    if (filter != null) {

      filter.onclick = () => {

        setTimeout(() => {
          var collectionGridPrice = document.querySelectorAll('.collection-grid .taxable--true .money')

          collectionGridPrice.forEach((m) => {
            let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
            updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection');
          })

        }, 3000);
        // setTimeout(() => {
        //   var nonGstList = document.querySelectorAll('.collection-grid .taxable--false')
        //   // nonGStUpdate(nonGstList)
        //   nonGstList.forEach(ng => {
        //     var sp = document.createElement('span');
        //     sp.classList.add('gst-free');
        //     sp.textContent = ' GST Free';
        //     if (ng.querySelector('.gst-free') == null) {
        //       ng.appendChild(sp);
        //     }
        //   })
        // }, 3050)
      }
      // var resetLinks = document.querySelectorAll('.facets__reset');
      // resetLinks.forEach((resetLink) => {
      //   resetLink.onclick = () => {
      //     setTimeout(() => {
      //       var nonGstList = document.querySelectorAll('.collection-grid .taxable--false')
      //       // nonGStUpdate(nonGstList)
      //       nonGstList.forEach(ng => {
      //         var sp = document.createElement('span');
      //         sp.classList.add('gst-free');
      //         sp.textContent = ' GST Free';
      //         if (ng.querySelector('.gst-free') == null) {
      //           ng.appendChild(sp);
      //         }
      //       })
      //     }, 3050)
      //   }
      // })

    }
    // on collection page filter click end 

    // on search  page price update
    var searchPrList = document.querySelectorAll('.search-wrapper .taxable--true .money');
    if (searchPrList != null) {
      searchPrList.forEach((m) => {
        let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
        updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection')
      })
    }
    // payment button text change
    window.onload = function () {
      var xy = setInterval(changeText, 500);
    }
    function changeText() {
      var tt = document.querySelector('.shopify-product-form .shopify-payment-button__more-options');

      if (tt != null) {
        tt.textContent = 'Buy It Now';
        //clearInterval(xy)
      }
    }


    // search page filter click
    var filter = document.querySelectorAll('.search-wrapper .facet-checkbox')
    var SortBy = document.querySelectorAll('.search-wrapper #SortBy')

    if (SortBy != null) {
      SortBy.forEach((sort) => {
        sort.onchange = () => {
          setTimeout(() => {
            var collectionGridPrice = document.querySelectorAll('.search-wrapper .taxable--true .money')
            collectionGridPrice.forEach((m) => {
              let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
              updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection');
              m.parentElement.classList.remove('loader')
            })

          }, 2000);
          // setTimeout(() => {
          //   var nonTaxableList = document.querySelectorAll('.search-wrapper .taxable--false');
          //   nonTaxableList.forEach(m => {
          //     console.log(m)
          //     m.innerHTML += " GST Free";
          //   })
          //   // nonGStUpdate(nonTaxableList)
          // }, 2050);
        }
      })
    }
    if (filter != null) {
      filter.forEach((filt) => {
        filt.onclick = () => {
          setTimeout(() => {
            var collectionGridPrice = document.querySelectorAll('.search-wrapper .taxable--true .money')
            var nonTaxableList = document.querySelectorAll('.search-wrapper .taxable--false')

            collectionGridPrice.forEach((m) => {
              let WIthGSTPriceNew = priceWIthGST(gst, m.textContent);
              updateGSTprice(m, WIthGSTPriceNew,null,null,'Collection');
              m.parentElement.classList.remove('loader')
            })
          }, 2500);
        }
      })
    }
    // on search  page end

  }
})

setTimeout(() => {
  var reviewBlock = document.querySelector('[data-block-handle="reviews"]');
  var reviewBlock2 = document.querySelector('.review_html');
  if (reviewBlock2 != null && reviewBlock != null) {
    reviewBlock2.appendChild(reviewBlock)
  }
  var ii = document.querySelector('.write-review-trigger');
  if (ii != null) {
    ii.addEventListener('click', () => {
      var trig = document.querySelector('.spr-summary-actions-newreview');
      trig.click();
    })
  }

}, 3000);

/// fixed height card read more

// document.addEventListener("DOMContentLoaded", () => {
//   const DEFAULT_HEIGHT = 615;
//   const COLLAPSED_HEIGHT = 120;
//   const NORMAL_FLEX = 1;
//   const EXPANDED_FLEX = 4;

//   const columns = document.querySelectorAll(
//     ".fixed_box_left, .fixed_box_right"
//   );

//   function syncColumnHeights() {
//     let maxHeight = 0;

//     columns.forEach((col) => {
//       col.style.height = "auto";
//       maxHeight = Math.max(maxHeight, col.scrollHeight);
//     });

//     columns.forEach((col) => {
//       col.style.height = maxHeight + "px";
//     });
//   }

//   function resetColumnHeights() {
//     columns.forEach((col) => {
//       col.style.height = DEFAULT_HEIGHT + "px";
//       col.style.overflow = "hidden";
//     });
//   }

//   columns.forEach((column) => {
//     const cards = Array.from(column.querySelectorAll(".fixed_cards"));
//     if (!cards.length) return;

//     const firstCard = cards[0];
//     const firstInner = firstCard.querySelector(".content_inner");

//     // -------- DEFAULT STATE --------
//     resetColumnHeights();

//     cards.forEach((card, index) => {
//       card.classList.remove("expanded");
//       card.style.flex = index === 0 ? "0 0 auto" : NORMAL_FLEX;

//       const inner = card.querySelector(".content_inner");
//       if (inner) {
//         inner.style.maxHeight = index === 0 ? "none" : COLLAPSED_HEIGHT + "px";
//         inner.style.overflow = "hidden"; // 🚫 no scrollbar
//       }

//       const btn = card.querySelector(".read_more_btn");
//       if (btn) {
//         btn.textContent = "Read More";
//         btn.style.display = index === 0 ? "none" : "inline-block";
//       }
//     });

//     // -------- OTHER CARDS --------
//     cards.slice(1).forEach((card) => {
//       const btn = card.querySelector(".read_more_btn");
//       const inner = card.querySelector(".content_inner");
//       if (!btn || !inner) return;

//       if (inner.scrollHeight <= COLLAPSED_HEIGHT) {
//         btn.style.display = "none";
//         return;
//       }

//       btn.addEventListener("click", () => {
//         const expanded = card.classList.contains("expanded");

//         if (expanded) {
//           // -------- READ LESS --------
//           cards.forEach((c, i) => {
//             c.classList.remove("expanded");
//             c.style.flex = i === 0 ? "0 0 auto" : NORMAL_FLEX;

//             const ci = c.querySelector(".content_inner");
//             if (ci) {
//               ci.style.maxHeight =
//                 i === 0 ? "none" : COLLAPSED_HEIGHT + "px";
//             }

//             const b = c.querySelector(".read_more_btn");
//             if (b) b.textContent = "Read More";
//           });

//           resetColumnHeights();
//         } else {
//           // -------- READ MORE --------
//           cards.forEach((c) => {
//             c.classList.remove("expanded");
//             c.style.flex = NORMAL_FLEX;

//             const ci = c.querySelector(".content_inner");
//             if (ci) ci.style.maxHeight = COLLAPSED_HEIGHT + "px";

//             const b = c.querySelector(".read_more_btn");
//             if (b) b.textContent = "Read More";
//           });

//           card.classList.add("expanded");
//           card.style.flex = EXPANDED_FLEX;
//           inner.style.maxHeight = "none";
//           btn.textContent = "Read Less";

//           // shrink first card visually
//           firstCard.style.flex = NORMAL_FLEX;
//           if (firstInner) firstInner.style.maxHeight = COLLAPSED_HEIGHT + "px";

//           // 🔥 sync both columns
//           syncColumnHeights();
//         }
//       });
//     });
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//   const DEFAULT_HEIGHT = 660;
//   const COLLAPSED_HEIGHT = 120;
//   const NORMAL_FLEX = 1;
//   const EXPANDED_FLEX = 4;

//   const columns = document.querySelectorAll(
//     ".fixed_box_left, .fixed_box_right"
//   );

//   function syncColumnHeights() {
//     let maxHeight = 0;

//     columns.forEach((col) => {
//       col.style.height = "auto";
//       maxHeight = Math.max(maxHeight, col.scrollHeight);
//     });

//     columns.forEach((col) => {
//       col.style.height = maxHeight + "px";
//     });
//   }

//   function resetColumnHeights() {
//     columns.forEach((col) => {
//       col.style.height = DEFAULT_HEIGHT + "px";
//       col.style.overflow = "hidden";
//     });
//   }

//   columns.forEach((column) => {
//     const cards = Array.from(column.querySelectorAll(".fixed_cards"));
//     if (!cards.length) return;

//     const isSingleCard = cards.length === 1;

//     const firstCard = cards[0];
//     const firstInner = firstCard.querySelector(".content_inner");

//     // -------- DEFAULT STATE --------
//     resetColumnHeights();

//     cards.forEach((card, index) => {
//       card.classList.remove("expanded");
//       card.style.flex = isSingleCard
//         ? NORMAL_FLEX
//         : index === 0
//         ? "0 0 auto"
//         : NORMAL_FLEX;

//       const inner = card.querySelector(".content_inner");
//       if (inner) {
//         inner.style.maxHeight = isSingleCard
//           ? COLLAPSED_HEIGHT + "px"
//           : index === 0
//           ? "none"
//           : COLLAPSED_HEIGHT + "px";

//         inner.style.overflow = "hidden";
//       }

//       const btn = card.querySelector(".read_more_btn");
//       if (btn) {
//         btn.textContent = "Read More";

//         if (isSingleCard) {
//           btn.style.display = "inline-block";
//         } else {
//           btn.style.display = index === 0 ? "none" : "inline-block";
//         }
//       }
//     });

//     // -------- CLICK HANDLING --------
//     (isSingleCard ? cards : cards.slice(1)).forEach((card) => {
//       const btn = card.querySelector(".read_more_btn");
//       const inner = card.querySelector(".content_inner");
//       if (!btn || !inner) return;

//       if (inner.scrollHeight <= COLLAPSED_HEIGHT) {
//         btn.style.display = "none";
//         return;
//       }

//       btn.addEventListener("click", () => {
//         const expanded = card.classList.contains("expanded");

//         if (expanded) {
//           // -------- READ LESS --------
//           cards.forEach((c, i) => {
//             c.classList.remove("expanded");
//             c.style.flex = isSingleCard
//               ? NORMAL_FLEX
//               : i === 0
//               ? "0 0 auto"
//               : NORMAL_FLEX;

//             const ci = c.querySelector(".content_inner");
//             if (ci) {
//               ci.style.maxHeight = isSingleCard
//                 ? COLLAPSED_HEIGHT + "px"
//                 : i === 0
//                 ? "none"
//                 : COLLAPSED_HEIGHT + "px";
//             }

//             const b = c.querySelector(".read_more_btn");
//             if (b) b.textContent = "Read More";
//           });

//           resetColumnHeights();
//         } else {
//           // -------- READ MORE --------
//           cards.forEach((c) => {
//             c.classList.remove("expanded");
//             c.style.flex = NORMAL_FLEX;

//             const ci = c.querySelector(".content_inner");
//             if (ci) ci.style.maxHeight = COLLAPSED_HEIGHT + "px";

//             const b = c.querySelector(".read_more_btn");
//             if (b) b.textContent = "Read More";
//           });

//           card.classList.add("expanded");
//           card.style.flex = EXPANDED_FLEX;
//           inner.style.maxHeight = "none";
//           btn.textContent = "Read Less";

//           if (!isSingleCard) {
//             firstCard.style.flex = NORMAL_FLEX;
//             if (firstInner)
//               firstInner.style.maxHeight = COLLAPSED_HEIGHT + "px";
//           }

//           syncColumnHeights();
//         }
//       });
//     });
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//   const NORMAL_FLEX = 1;
//   const DEFAULT_HEIGHT = 615; // collapsed height

//   const columns = document.querySelectorAll(".fixed_box_left, .fixed_box_right");

//   function syncColumnHeights() {
//     let maxHeight = 0;
//     columns.forEach((col) => {
//       col.style.height = "auto";
//       maxHeight = Math.max(maxHeight, col.scrollHeight);
//     });
//     columns.forEach((col) => {
//       col.style.height = maxHeight + "px";
//     });
//   }

//   function resetColumnHeights() {
//     columns.forEach((col) => {
//       col.style.height = DEFAULT_HEIGHT + "px";
//     });
//   }

//   columns.forEach((column) => {
//     const cards = Array.from(column.querySelectorAll(".fixed_cards"));
//     if (!cards.length) return;

//     // ---------- INIT ----------
//     cards.forEach((card) => {
//       const isBenefits = card.classList.contains("benefits");

//       card.classList.remove("expanded");
//       card.style.flex = NORMAL_FLEX;

//       const inner = card.querySelector(".content_inner");
//       if (inner) {
//         inner.style.overflow = isBenefits ? "visible" : "hidden";
//       }

//       const btn = card.querySelector(".read_more_btn");
//       if (btn) {
//         btn.textContent = "Read More";
//         btn.style.display = "block";
//       }
//     });

//     // ---------- CLICK HANDLER ----------
//     cards.forEach((card) => {
//       const btn = card.querySelector(".read_more_btn");
//       const inner = card.querySelector(".content_inner");
//       if (!btn || !inner) return;

//       btn.addEventListener("click", () => {
//         const isBenefits = card.classList.contains("benefits");
//         const isExpanded = card.classList.contains("expanded");

//         // 🔒 BENEFITS CARD → NEVER COLLAPSE
//         if (isBenefits) {
//           card.classList.add("expanded");
//           card.style.flex = "auto";
//           inner.style.overflow = "visible";
//           btn.textContent = "Read Less";
//           syncColumnHeights();
//           return;
//         }

//         // ---------- READ LESS ----------
//         if (isExpanded) {
//           card.classList.remove("expanded");
//           card.style.flex = NORMAL_FLEX;
//           inner.style.overflow = "hidden";
//           btn.textContent = "Read More";

//           resetColumnHeights();
//           return;
//         }

//         // ---------- COLLAPSE OTHER NON-BENEFITS ----------
//         cards.forEach((c) => {
//           if (c !== card && !c.classList.contains("benefits")) {
//             c.classList.remove("expanded");
//             c.style.flex = NORMAL_FLEX;

//             const ci = c.querySelector(".content_inner");
//             if (ci) ci.style.overflow = "hidden";

//             const b = c.querySelector(".read_more_btn");
//             if (b) b.textContent = "Read More";
//           }
//         });

//         // ---------- EXPAND CLICKED CARD ----------
//         card.classList.add("expanded");
//         card.style.flex = "auto";
//         inner.style.overflow = "visible";
//         btn.textContent = "Read Less";

//         syncColumnHeights();
//       });
//     });
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//   const NORMAL_FLEX = 1;
//   const DEFAULT_HEIGHT = 615; // collapsed height

//   const columns = document.querySelectorAll(".fixed_box_left, .fixed_box_right");

//   function syncColumnHeights() {
//     let maxHeight = 0;
//     columns.forEach((col) => {
//       col.style.height = "auto";
//       maxHeight = Math.max(maxHeight, col.scrollHeight);
//     });
//     columns.forEach((col) => {
//       col.style.height = maxHeight + "px";
//     });
//   }

//   function resetColumnHeights() {
//     columns.forEach((col) => {
//       col.style.height = DEFAULT_HEIGHT + "px";
//     });
//   }

//   columns.forEach((column) => {
//     const cards = Array.from(column.querySelectorAll(".fixed_cards"));
//     if (!cards.length) return;

//     // ---------- INIT ----------
//     cards.forEach((card) => {
//       const isBenefits = card.classList.contains("benefits");

//       card.classList.remove("expanded");

//       // ✅ FIX: do NOT apply flex to benefits card
//       if (!isBenefits) {
//         card.style.flex = NORMAL_FLEX;
//       } else {
//         card.style.flex = ""; // let CSS control it
//       }

//       const inner = card.querySelector(".content_inner");
//       if (inner) {
//         inner.style.overflow = isBenefits ? "visible" : "hidden";
//       }

//       const btn = card.querySelector(".read_more_btn");
//       if (btn) {
//         btn.textContent = "Read More";
//         btn.style.display = "block";
//       }
//     });

//     // ---------- CLICK HANDLER ----------
//     cards.forEach((card) => {
//       const btn = card.querySelector(".read_more_btn");
//       const inner = card.querySelector(".content_inner");
//       if (!btn || !inner) return;

//       btn.addEventListener("click", () => {
//         const isBenefits = card.classList.contains("benefits");
//         const isExpanded = card.classList.contains("expanded");

//         // 🔒 BENEFITS CARD → always full, never flexed
//         if (isBenefits) {
//           card.classList.add("expanded");
//           card.style.flex = ""; // ✅ still no flex: 1
//           inner.style.overflow = "visible";
//           btn.textContent = "Read Less";
//           syncColumnHeights();
//           return;
//         }

//         // ---------- READ LESS ----------
//         if (isExpanded) {
//           card.classList.remove("expanded");
//           card.style.flex = NORMAL_FLEX;
//           inner.style.overflow = "hidden";
//           btn.textContent = "Read More";

//           resetColumnHeights();
//           return;
//         }

//         // ---------- COLLAPSE OTHER NON-BENEFITS ----------
//         cards.forEach((c) => {
//           if (c !== card && !c.classList.contains("benefits")) {
//             c.classList.remove("expanded");
//             c.style.flex = NORMAL_FLEX;

//             const ci = c.querySelector(".content_inner");
//             if (ci) ci.style.overflow = "hidden";

//             const b = c.querySelector(".read_more_btn");
//             if (b) b.textContent = "Read More";
//           }
//         });

//         // ---------- EXPAND CLICKED CARD ----------
//         card.classList.add("expanded");
//         card.style.flex = "auto";
//         inner.style.overflow = "visible";
//         btn.textContent = "Read Less";

//         syncColumnHeights();
//       });
//     });
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".product-descriptoon-thermoskin").forEach((content) => {

//     const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
//     const maxLines = 3;

//     if (content.scrollHeight <= lineHeight * maxLines + 1) return;

//     const button = document.createElement("button");
//     button.type = "button";
//     button.className = "read-more-btn";
//     button.innerHTML = `
//       <span class="read-more-text">READ MORE</span>
//       <span class="read-more-icon"></span>
//     `;

//     content.after(button);

//     button.addEventListener("click", function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       content.classList.toggle("expanded");
//       button.classList.toggle("active");

//       button.querySelector(".read-more-text").textContent =
//         content.classList.contains("expanded") ? "READ LESS" : "READ MORE";
//     });
//   });
// });


// fixed card read more and read less
// document.addEventListener("DOMContentLoaded", () => {
//   const cards = document.querySelectorAll(".fixed_cards");

//   cards.forEach(card => {
//     const contentInner = card.querySelector(".content_inner");
//     const btn = card.querySelector(".read_more_btn");

//     if (!contentInner || !btn) return;

//     const ul = contentInner.querySelector("ul");
//     const p = contentInner.querySelector("p");

//     // if (!p) {
//     //   btn.style.display = "none";
//     //   return;
//     // }

//     // 🚫 Hide button if content_inner is empty
//     if (!contentInner.textContent.trim()) {
//       btn.style.display = "none";
//       return;
//     }

//     let collapsedHeight = 0;
//     let shouldHideButton = false;

//     // ---------- UL (3 li) ----------
//     if (ul) {
//       const liItems = ul.querySelectorAll("li");

//       if (liItems.length <= 3) {
//         shouldHideButton = true;
//       } else {
//         for (let i = 0; i < 3; i++) {
//           collapsedHeight += liItems[i].offsetHeight;
//         }
//       }
//     }

//     // ---------- P (2 lines) ----------
//     if (p) {
//       const style = window.getComputedStyle(p);
//       const lineHeight = parseFloat(style.lineHeight);
//       const fullHeight = p.scrollHeight;
//       collapsedHeight = lineHeight * 3;

//       if (fullHeight <= collapsedHeight) {
//         shouldHideButton = true;
//       }
//     }

//     // ---------- Hide button if not needed ----------
//     if (shouldHideButton) {
//       btn.style.display = "none";
//       return;
//     }

//     // ---------- Initial styles ----------
//     contentInner.style.overflow = "hidden";
//     contentInner.style.maxHeight = collapsedHeight + "px";
//     contentInner.style.transition = "max-height 0.4s ease";

//     // ---------- Toggle ----------
//     btn.addEventListener("click", () => {
//       const isExpanded = contentInner.classList.contains("expanded");

//       if (isExpanded) {
//         contentInner.style.maxHeight = collapsedHeight + "px";
//         btn.textContent = "Read More";
//         contentInner.classList.remove("expanded");
//       } else {
//         contentInner.style.maxHeight = contentInner.scrollHeight + "px";
//         btn.textContent = "Read Less";
//         contentInner.classList.add("expanded");
//       }
//     });
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//   const cards = document.querySelectorAll(".fixed_cards");

//   cards.forEach(card => {
//     const contentInner = card.querySelector(".content_inner");
//     const btn = card.querySelector(".read_more_btn");

//     if (!contentInner || !btn) return;

//     const ul = contentInner.querySelector("ul");
//     const p = contentInner.querySelector("p");

//     // 🚀 NEW: Detect "Best For" heading and mark its section
//     const headings = card.querySelectorAll("h3");
//     headings.forEach(h3 => {
//       if (h3.textContent.trim().toLowerCase() === "best for") {
//         const nextContent = h3.nextElementSibling;
//         if (nextContent && nextContent.classList.contains("content_inner")) {
//           nextContent.classList.add("best-for-section");
//         }
//       }
//     });

//     // 🚫 Hide button if content_inner is empty
//     if (!contentInner.textContent.trim()) {
//       btn.style.display = "none";
//       return;
//     }

//     let collapsedHeight = 0;
//     let shouldHideButton = false;

//     // ---------- UL (3 li) ----------
//     if (ul) {
//       const liItems = ul.querySelectorAll("li");

//       if (liItems.length <= 3) {
//         shouldHideButton = true;
//       } else {
//         for (let i = 0; i < 3; i++) {
//           collapsedHeight += liItems[i].offsetHeight;
//         }
//       }
//     }

//     // ---------- P (3 lines) ----------
//     if (p) {
//       const style = window.getComputedStyle(p);
//       const lineHeight = parseFloat(style.lineHeight);
//       const fullHeight = p.scrollHeight;
//       collapsedHeight = lineHeight * 3;

//       if (fullHeight <= collapsedHeight) {
//         shouldHideButton = true;
//       }
//     }

//     // ---------- Hide button if not needed ----------
//     if (shouldHideButton) {
//       btn.style.display = "none";
//       return;
//     }

//     // ---------- Initial styles ----------
//     contentInner.style.overflow = "hidden";
//     contentInner.style.maxHeight = collapsedHeight + "px";
//     contentInner.style.transition = "max-height 0.4s ease";

//     // ---------- Toggle ----------
//     btn.addEventListener("click", () => {
//       const isExpanded = contentInner.classList.contains("expanded");

//       if (isExpanded) {
//         contentInner.style.maxHeight = collapsedHeight + "px";
//         btn.textContent = "Read More";
//         contentInner.classList.remove("expanded");
//       } else {
//         contentInner.style.maxHeight = contentInner.scrollHeight + "px";
//         btn.textContent = "Read Less";
//         contentInner.classList.add("expanded");
//       }
//     });

//   });
// });
document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".fixed_cards");

  cards.forEach(card => {

    const contentInner = card.querySelector(".content_inner");
    const btn = card.querySelector(".read_more_btn");

    if (!contentInner || !btn) return;

    const ul = contentInner.querySelector("ul");
    const p  = contentInner.querySelector("p");

    // 🚀 Detect Best For section (your original logic preserved)
    const headings = card.querySelectorAll("h3");
    headings.forEach(h3 => {
      if (h3.textContent.trim().toLowerCase() === "best for") {
        const nextContent = h3.nextElementSibling;
        if (nextContent && nextContent.classList.contains("content_inner")) {
          nextContent.classList.add("best-for-section");
        }
      }
    });

    // 🚫 Hide button if empty
    if (!contentInner.textContent.trim()) {
      btn.style.display = "none";
      return;
    }

    let collapsedHeight = 0;
    let shouldHideButton = false;

    // ======================================================
    // ⭐ BENEFITS CARD (SHOW ONLY 2 LI)
    // ======================================================
    if (card.classList.contains("benefits") && ul) {

      const liItems = ul.querySelectorAll("li");

      if (liItems.length <= 2) {
        shouldHideButton = true;
      } else {
        collapsedHeight = 0;
        for (let i = 0; i < 2; i++) {
          collapsedHeight += liItems[i].offsetHeight;
        }
      }

    }

    // ======================================================
    // ---------- UL (DEFAULT LOGIC FOR OTHER CARDS) ----------
    // ======================================================
    // else if (ul) {

    //   const liItems = ul.querySelectorAll("li");

    //   if (liItems.length <= 2) {
    //     shouldHideButton = true;
    //   } else {
    //     collapsedHeight = 0;
    //     for (let i = 0; i < 2; i++) {
    //       collapsedHeight += liItems[i].offsetHeight;
    //     }
    //   }

    // }

    // ======================================================
    // ---------- P (3 lines) ----------
    // ======================================================
    if (p) {

      const style = window.getComputedStyle(p);
      let lineHeight = parseFloat(style.lineHeight);

      if (isNaN(lineHeight)) {
        lineHeight = parseFloat(style.fontSize) * 1.2;
      }

      const fullHeight = p.scrollHeight;
      const threeLinesHeight = lineHeight * 3;

      collapsedHeight = threeLinesHeight;

      if (fullHeight <= threeLinesHeight) {
        shouldHideButton = true;
      }
    }

    // ---------- Hide button if not needed ----------
    if (shouldHideButton) {
      btn.style.display = "none";
      return;
    }

    // ---------- Initial collapsed state ----------
    contentInner.style.overflow = "hidden";
    contentInner.style.maxHeight = collapsedHeight + "px";
    contentInner.style.transition = "max-height 0.4s ease";

    // ---------- Toggle ----------
    btn.addEventListener("click", () => {

      const isExpanded = contentInner.classList.contains("expanded");

      if (isExpanded) {

        // Collapse
        contentInner.style.maxHeight = collapsedHeight + "px";
        btn.textContent = "Read More";
        contentInner.classList.remove("expanded");

      } else {

        // Expand
        contentInner.style.maxHeight = contentInner.scrollHeight + "px";
        btn.textContent = "Read Less";
        contentInner.classList.add("expanded");

      }

    });

  });

});
// document.addEventListener("DOMContentLoaded", () => {
//   const cards = document.querySelectorAll(".fixed_cards");

//   cards.forEach(card => {
//     const contentInners = card.querySelectorAll(".content_inner");
//     const btn = card.querySelector(".read_more_btn");

//     if (!contentInners.length || !btn) return;

//     let collapsedHeights = [];
//     let shouldHideButton = true;

//     contentInners.forEach((contentInner, index) => {
//       const ul = contentInner.querySelector("ul");
//       const p = contentInner.querySelector("p");

//       if (!contentInner.textContent.trim()) return;

//       let collapsedHeight = 0;

//       // ---------- UL (3 li) ----------
//       if (ul) {
//         const liItems = ul.querySelectorAll("li");

//         if (liItems.length > 3) {
//           shouldHideButton = false;
//           for (let i = 0; i < 3; i++) {
//             collapsedHeight += liItems[i].offsetHeight;
//           }
//         } else {
//           collapsedHeight = contentInner.scrollHeight;
//         }
//       }

//       // ---------- P (3 lines) ----------
//       if (p) {
//         const style = window.getComputedStyle(p);
//         const lineHeight = parseFloat(style.lineHeight);
//         const fullHeight = p.scrollHeight;
//         collapsedHeight = lineHeight * 3;

//         if (fullHeight > collapsedHeight) {
//           shouldHideButton = false;
//         } else {
//           collapsedHeight = fullHeight;
//         }
//       }

//       collapsedHeights[index] = collapsedHeight;

//       // Apply initial collapse
//       contentInner.style.overflow = "hidden";
//       contentInner.style.maxHeight = collapsedHeight + "px";
//       contentInner.style.transition = "max-height 0.4s ease";
//     });

//     // ---------- Hide button if not needed ----------
//     if (shouldHideButton) {
//       btn.style.display = "none";
//       return;
//     }

//     // ---------- Toggle ----------
//     btn.addEventListener("click", () => {
//       const isExpanded = card.classList.contains("expanded");

//       contentInners.forEach((contentInner, index) => {
//         if (isExpanded) {
//           contentInner.style.maxHeight = collapsedHeights[index] + "px";
//         } else {
//           contentInner.style.maxHeight = contentInner.scrollHeight + "px";
//         }
//       });

//       if (isExpanded) {
//         btn.textContent = "Read More";
//         card.classList.remove("expanded");
//       } else {
//         btn.textContent = "Read Less";
//         card.classList.add("expanded");
//       }
//     });
//   });
// });

/// product custom accordion

document.querySelectorAll("#product_accordion .accordion-toggle").forEach((btn) => {
  btn.addEventListener("click", () => {
    const item = btn.closest(".accordion-item");
    const icon = btn.querySelector(".icon");

    item.classList.toggle("active");

    icon.textContent = item.classList.contains("active") ? "−" : "+";
  });
});


//// product support level static scrollbar 

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-scrollbar").forEach((scrollbar) => {
    const progress = scrollbar.querySelector(".scrollbar-progress");
    const labels = scrollbar.querySelectorAll(".scrollbar_bottom_text span");

    if (!progress || !labels.length) return;

    // get width % from inline style
    const widthPercent = parseFloat(progress.style.width);

    // reset all
    labels.forEach((label) => label.classList.remove("active"));

    if (widthPercent <= 25) {
      labels[0].classList.add("active"); // Mild
    } else if (widthPercent <= 50) {
      labels[1].classList.add("active"); // Moderate
    } else if (widthPercent <= 75) {
      labels[2].classList.add("active"); // Stabilising
    } else {
      labels[3].classList.add("active"); // Advanced Stabilising
    }
  });
});

///////// Product support level image popup

// document.addEventListener("DOMContentLoaded", () => {
//   const support_level = document.querySelector('.support_level_container');
//   const support_lvl_img = document.querySelector('.support_lvl_img');
//   const support_close = document.querySelector('.support_close');

//   if (support_level && support_lvl_img) {
//     support_level.addEventListener('click', () => {
//       support_lvl_img.style.display = "flex";
//     });
//   }

//   if (support_close && support_lvl_img) {
//     support_close.addEventListener('click', () => {
//       support_lvl_img.style.display = "none";
//     });
//   }

// });
document.addEventListener("click", function (e) {

  // OPEN modal
  const trigger = e.target.closest(".support_level_container");
  if (trigger) {
    const modal = document.querySelector(".support_lvl_img");
    if (modal) {
      modal.style.display = "flex";
    }
  }

  // CLOSE modal
  const closeBtn = e.target.closest(".support_close");
  if (closeBtn) {
    const modal = document.querySelector(".support_lvl_img");
    if (modal) {
      modal.style.display = "none";
    }
  }

  // CLOSE when clicking outside container (optional but recommended)
  const modal = document.querySelector(".support_lvl_img");
  if (modal && e.target === modal) {
    modal.style.display = "none";
  }

});

